import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30597ca8")

_pushScopeId("data-v-30597ca8")
const _hoisted_1 = { class: "trend" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = { class: "member clearfix" }
const _hoisted_4 = { class: "img fl" }
const _hoisted_5 = { class: "info fl" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "info fl" }
const _hoisted_8 = { class: "info fl" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"height":"1px"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_TrendItem = _resolveComponent("TrendItem")
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_van_image, {
            round: "",
            fit: "cover",
            width: "1.45rem",
            height: "1.45rem",
            src: _ctx.userInfo?.avatarUrl || _ctx.defaultAvatar
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.userInfo.userName ?? "-"), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          (_ctx.userInfo?.sex == '男')
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                src: require('@/assets/img/health/female.png'),
                class: "sexicon"
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock(_component_van_image, {
                key: 1,
                src: require('@/assets/img/health/male.png'),
                class: "sexicon"
              }, null, 8, ["src"]))
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.userInfo?.age ?? '-') + "岁", 1)
        ])
      ])
    ]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_van_tab, { title: "最近7天" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 7 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近1月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 30 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近3月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 90 })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "最近6月" }, {
          default: _withId(() => [
            _createVNode(_component_TrendItem, { dayLength: 180 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _hoisted_10
  ]))
})